// Pure decision helper for the SMS provider-phone Save action. Given the typed
// draft and the user's current phone, returns what API calls are needed. Kept
// in CommonJS so Jest can require() it (no ESM transform); esbuild bundles it
// into the v3 ESM bundle fine.
//
// E.164: leading '+', first digit 1-9, total 8-15 digits — matches the server
// guard in server/routes/smsAdmin.js POST /config/phones.
function planProviderPhoneSave(draft, currentPhone) {
  const d = (draft || '').trim();
  const cur = currentPhone || null;
  if (d === (cur || '')) return { action: 'none' };
  if (d === '') return { action: 'remove', remove: cur };
  if (!/^\+[1-9]\d{7,14}$/.test(d)) return { action: 'invalid' };
  return { action: 'set', add: d, removeOld: (cur && cur !== d) ? cur : null };
}

module.exports = { planProviderPhoneSave };
